<script setup>
import { storeToRefs } from "pinia";
import { useCotizacionEstandarStore } from "@/store/cotizaciones/estandar";
import { useCotizacionEstandarCalculosTabla } from "@/composables/useCotizacionEstandar";
import useCotizacionEstandarSourcesStore from "@/store/cotizaciones/estandar/sources";
import useUtil from "@/composables/useUtil";
const { formatoMoneda } = useUtil();
const { state, stateCotizacion } = storeToRefs(useCotizacionEstandarStore());
const {
  PMT,
  IPMT,
  PPMT,
  RESVAL,
  CF,
  tabla,
} = useCotizacionEstandarCalculosTabla();
const { netVat } = storeToRefs(useCotizacionEstandarSourcesStore());
</script>

<template>
  <section>
    <div class="table-responsive">
      <table class="table table-sm text-xs table-bordered text-center">
        <thead>
          <tr>
            <th colspan="8" class="bg-light">
              TOTAL LEASE CF (*Not Divided into Draw 1 & 2)
            </th>
            <th></th>
            <th colspan="6" class="bg-light">VAT</th>
          </tr>
          <tr>
            <th colspan="3"></th>
            <th>-</th>
            <th>-</th>
            <th>-</th>
            <th>-</th>
            <th>-</th>
            <th></th>
            <th></th>
            <th>-</th>
            <th>-</th>
            <th>-</th>
            <th>-</th>
            <th>${{ netVat }}</th>
          </tr>
          <tr>
            <th>Year</th>
            <th>Date</th>
            <th>Month</th>
            <th>IPMT</th>
            <th>PPMT</th>
            <th>PMT</th>
            <th>Residual</th>
            <th>CF</th>
            <th></th>
            <th>VAT Prepaid Begin Bal</th>
            <th>VAT to Be Collected</th>
            <th>VAT to be Kept</th>
            <th>VAT Refund</th>
            <th>Net VAT</th>
            <th>VAT Prepaid End Bal</th>
          </tr>
        </thead>
        <tbody></tbody>
        <tbody>
          <tr
            v-for="(row, index) in tabla"
            :key="row.month"
            :class="index == 0 ? 'bg-secondary text-white' : ''"
          >
            <td>{{ row.year }}</td>
            <td>{{ row.date }}</td>
            <td>{{ row.month }}</td>
            <td>{{ formatoMoneda(row.ipmt) }}</td>
            <td>{{ formatoMoneda(row.ppmt) }}</td>
            <td>{{ formatoMoneda(row.pmt) }}</td>
            <td>{{ formatoMoneda(row.residual) }}</td>
            <td>{{ formatoMoneda(row.cf) }}</td>
            <td></td>
            <td>{{ row.vatPrepaidBegin }}</td>
            <td>{{ row.vatToBeCollected }}</td>
            <td>{{ row.vatToBeKept }}</td>
            <td>{{ row.vatRefund }}</td>
            <td>{{ row.netVat }}</td>
            <td>{{ row.vatPrepaidEnd }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>
